export const API_CONSTANTS = Object.freeze({
  GET_RADIOLOGY_REPORTS: "/order-report/retrieve-order-reports",
  ORDER_REPORT: "/order-report/create-order-report",
  ORDER_REPORT_ESLEWHERE: "/order-report/create-else-where-order-report",
});
